module.exports = __webpack_public_path__ + "static/media/mari.6eab9297.jpeg";